import script from "./AddressAutocompleteField.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressAutocompleteField.vue?vue&type=script&setup=true&lang=ts"

import "./AddressAutocompleteField.vue?vue&type=style&index=0&id=533e3c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-533e3c36"]])

export default __exports__